import { useEffect } from "react";
import { pageTitle } from "../lib/brand";

/** Sets `<title> • Clockify` (brand name from lib/brand) while the calling page is mounted. */
export function usePageTitle(title: string | undefined) {
  useEffect(() => {
    if (title) document.title = pageTitle(title);
  }, [title]);
}
